import {
    classNamesFunction,
    IStyle,
} from '@fluentui/react';
import { IThemedProp } from './themesUI';

export interface IAlchemyInsightsCardStyles {
    card: IStyle;
    cardheaderSection: IStyle;
    cardHeader: IStyle;
    cardFooterSection: IStyle;
    solutionIcon: IStyle;
    expandCollapseIcon: IStyle;
    iconSection: IStyle;
    icon: IStyle;
    alchemyInsightSnipet: IStyle;
    seeMoreSection: IStyle;
}

interface AlchemyInsightsCardStylesProps {
    isSignUp?: boolean;
    showMoreInsightsExpanded?: boolean;
}

export const getAlchemyInsightsStyles = (props: IThemedProp & AlchemyInsightsCardStylesProps): IAlchemyInsightsCardStyles => {
    const { theme, isSignUp, showMoreInsightsExpanded } = props;
    return {
        card: {
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            boxShadow: '0 2px 4px rgb(0 0 0 / 10%)',
            overflow: 'hidden',
            borderRadius: '3px',
            lineHeight: '1.5',
            fontSize: '14px',
            fontFamily: '"Segoe UI ", "Segoe UI Web ", "wf_segoe-ui_normal","Helvetica Neue", "BBAlpha Sans", "S60 Sans", Arial, sans-serif',
        },
        cardheaderSection: {
            backgroundColor: theme.palette.neutralQuaternary,
            padding: '10px',
        },
        cardHeader: {
            padding: '0',
            fontWeight: '500',
            margin: '0',
            fontFamily: "'Segoe UI Semibold','wf_segoe-ui_semibold','wf_segoe-ui_normal','Segoe UI','Segoe WP',Tahoma,Arial,sans-serif",
        },
        cardFooterSection: {
            padding: '2px 10px 10px 10px',
            color: theme.palette.neutralPrimary,
            hr: {
                height: '1px',
                border: '0',
                borderTop: '1px solid',
                padding: '1px 0 6px 0',
                margin: '0',
            },
        },
        expandCollapseIcon: {
            color: theme.semanticColors.link,
            cursor: 'pointer',
            float: 'right',
            fontSize: '16px',
            fontWeight: '500',
            margin: '2px 0',
            verticalAlign: 'middle',
        },
        solutionIcon: {
            verticalAlign: 'middle',
            fontSize: '16px',
            fontWeight: '500',
            margin: '2px 0',
            color: theme.palette.neutralPrimary,
        },
        iconSection: {
            margin: '0',
            lineHeight: '2',
        },
        icon: {
            fontSize: '18px',
            lineHeight: '16px',
            '@media only screen and (max-width: 480px) ': {
                fontSize: '16px',
                lineHeight: '14px',
            },
        },
        alchemyInsightSnipet: {
            padding: '10px 10px 0 10px',
            color: theme.palette.neutralPrimary,
            a: {
                color: theme.semanticColors.link,
                selectors: {
                    ':hover': {
                        textDecoration: 'none',
                        cursor: 'pointer',
                    },
                },
                textDecoration: 'underline !important',
            },
            p: {
                fontSize: 'inherit',
            },
            button: {
                backgroundColor: `${theme.palette.themePrimary} !important`,
                color: `${theme.semanticColors.primaryButtonText} !important`,
                border: ` 1px solid ${theme.palette.themeTertiary} !important`,
                selectors: {
                    ':hover': {
                        backgroundColor: `${theme.palette.themeDarkAlt} !important`,
                        color: `${theme.semanticColors.primaryButtonText} !important`,
                    },
                },
            },
            maxHeight: isSignUp && !showMoreInsightsExpanded ? 'calc(100vh - 490px)' : 'none',
        },
        seeMoreSection: {
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%',
            bottom: '0',
            position: showMoreInsightsExpanded ? 'relative' : 'absolute',
            padding: '10px 10px 10px 0px',
        }
    };
};

export const getAlchemyInsightsClassnames = classNamesFunction<{}, IAlchemyInsightsCardStyles>();
